import React, { useEffect, useState } from "react";
import "./Featured.scss";
import featured from "../../assets/images/featured.png";
import featureddao from "../../assets/images/featureddao.png";
import featuredblur from "../../assets/images/featuredblur.png";
import triangle from "../../assets/images/triangle.png";
import circle from "../../assets/images/circle.png";
import plus from "../../assets/images/plus.png";

import { motion, useTransform, useViewportScroll } from "framer-motion";

function Featured() {
  const [delay, setdelay] = useState(0.4);
  useEffect(() => {
    if (window.innerWidth < 991) {
      setdelay(0);
    } else {
      setdelay(0.4);
    }
    window.addEventListener("resize", () => {
      if (window.innerWidth < 991) {
        setdelay(0);
      } else {
        setdelay(0.4);
      }
    });
  });
  const { scrollYProgress } = useViewportScroll();
  const scale = useTransform(scrollYProgress, [0, delay], [0.7, 1]);
  const opacity = useTransform(scrollYProgress, [0, delay], [0, 1]);
  return (
    <section className="featured">
      <div className="container">
        <div className="b-top"></div>
        <div style={{ textAlign: "center " }}>
          <img src={featured} alt="" className="featured-image" />
        </div>

        <motion.h2 className="secheading upheav" style={{ scale, opacity }}>
          Featured Daos
        </motion.h2>

        <motion.div className="featured-grid" style={{ scale, opacity }}>
          <FeaturedItem
            bg={featureddao}
            bottomText={"Coming Soon"}
            shape={triangle}
          />
          <FeaturedItem
            bg={featureddao}
            bottomText={"Coming Soon"}
            shape={circle}
          />
          <FeaturedItem
            shape={plus}
            bg={featureddao}
            apply={["Apply to be a DAO"]}
            bottomText={"Register Now"}
          />
        </motion.div>
      </div>
    </section>
  );
}

export default Featured;

const FeaturedItem = ({ bg, apply, bottomText, shape }) => {
  return (
    <div className="featured-item">
      <img src={bg} alt="" className="back" />
      <div className="daoimage">
        <img src={shape} alt="" />
      </div>
      {apply && <div className="applytext">{apply}</div>}
      <div className="daoname">{bottomText}</div>
    </div>
  );
};
